(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brand-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pe-brand-film')) {
    customElements.define('pe-brand-film', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const launch = this.querySelector('[data-film-launch]');
        const dialog = this.querySelector('dialog');
        const video = this.querySelector('video');
        const error = this.querySelector('[data-film-error]');
        const loading = this.querySelector('[data-film-loading]');
        const playButton = this.querySelector('[data-film-play]');
        const soundButton = this.querySelector('[data-film-sound]');
        const mobileHero = this.closest('.hero-motion') ? window.matchMedia('(max-width: 700px)') : null;
        const syncControls = () => {
          playButton.textContent = video.paused ? playButton.dataset.playLabel : playButton.dataset.pauseLabel;
          soundButton.textContent = video.muted ? soundButton.dataset.unmuteLabel : soundButton.dataset.muteLabel;
        };
        const startPlayback = () => {
          error.hidden = true;
          loading.hidden = false;
          clearTimeout(this.loadTimer);
          this.loadTimer = setTimeout(() => {
            if (dialog.open && video.readyState < 3) {
              loading.hidden = true;
              error.hidden = false;
            }
          }, 12000);
          video.play().then(() => {
            loading.hidden = true;
            clearTimeout(this.loadTimer);
          }).catch(() => {
            loading.hidden = true;
            clearTimeout(this.loadTimer);
            if (dialog.open) error.hidden = false;
          });
        };
        if (!dialog.showModal) return;
        launch.setAttribute('aria-haspopup', 'dialog');
        launch.addEventListener('click', (event) => {
          if (mobileHero && !mobileHero.matches) {
            event.preventDefault();
            return;
          }
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const mobile = window.matchMedia('(max-width: 600px)').matches;
          const source = mobile ? video.dataset.mobile : video.dataset.desktop;
          const poster = mobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
          video.poster = poster;
          video.muted = true;
          video.preload = 'auto';
          if (!dialog.open) dialog.showModal();
          document.dispatchEvent(new Event('pe:film-open'));
          if (video.getAttribute('src') !== source) {
            video.src = source;
          } else if (video.readyState > 0) {
            video.currentTime = 0;
          }
          this.querySelector('[data-film-direct]').href = source;
          startPlayback();
        }, options);
        this.querySelectorAll('[data-film-close]').forEach((button) => {
          button.addEventListener('click', () => dialog.close(), options);
        });
        playButton.addEventListener('click', () => {
          if (video.paused) startPlayback();
          else video.pause();
        }, options);
        soundButton.addEventListener('click', () => { video.muted = !video.muted; }, options);
        ['play', 'pause', 'ended', 'volumechange'].forEach((name) => video.addEventListener(name, syncControls, options));
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          video.pause();
          clearTimeout(this.loadTimer);
          loading.hidden = true;
          launch.focus({ preventScroll: true });
          document.dispatchEvent(new Event('pe:film-close'));
        }, options);
        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            dialog.close();
          }
        }, options);
        video.addEventListener('error', () => { error.hidden = false; }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) video.pause();
        }, options);
        mobileHero?.addEventListener('change', () => {
          if (!mobileHero.matches) {
            video.pause();
            if (dialog.open) dialog.close();
          }
        }, options);
      }
      disconnectedCallback() {
        this.querySelector('video')?.pause();
        clearTimeout(this.loadTimer);
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pe-hero-motion')) {
    customElements.define('pe-hero-motion', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        const mobile = window.matchMedia('(max-width: 700px)');
        video.defaultMuted = true;
        video.muted = true;
        let manuallyPaused = false;
        let onScreen = true;
        const sync = () => {
          button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
          button.setAttribute('aria-pressed', String(!video.paused));
        };
        const play = () => {
          if (!mobile.matches) return;
          if (!video.getAttribute('src')) {
            video.preload = 'auto';
            video.src = video.dataset.source;
          }
          video.muted = true;
          video.play().catch(sync);
        };
        button.addEventListener('click', () => {
          manuallyPaused = !video.paused;
          if (video.paused) play(); else video.pause();
        }, options);
        ['play', 'pause', 'error'].forEach(name => video.addEventListener(name, sync, options));
        sync();
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          onScreen = entries[0].isIntersecting;
          if (!onScreen || document.hidden) video.pause();
          else if (!manuallyPaused && !document.querySelector('pe-brand-film dialog[open]')) play();
        }, { threshold: .15 });
        this.observer.observe(this);
        mobile.addEventListener('change', () => {
          if (!mobile.matches) {
            video.pause();
            video.removeAttribute('src');
            video.preload = 'none';
            video.load();
          } else if (onScreen && !document.hidden && !manuallyPaused && !document.querySelector('pe-brand-film dialog[open]')) play();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) video.pause();
          else if (onScreen && !manuallyPaused && !document.querySelector('pe-brand-film dialog[open]')) play();
        }, options);
        document.addEventListener('pe:film-open', () => video.pause(), options);
        document.addEventListener('pe:film-close', () => {
          if (onScreen && !manuallyPaused && !document.hidden) play();
        }, options);
      }
      disconnectedCallback() {
        this.querySelector('video')?.pause();
        this.observer?.disconnect();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', async (event) => {
    const select = event.target.closest('.product-card select[data-option-position]');
    if (!select) return;
    const card = select.closest('.product-card');
    const selectors = [...card.querySelectorAll('[data-option-position]')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    const selected = selectors.map(item => item.value);
    const ids = selectors.map(item => item.selectedOptions[0].dataset.optionValueId);
    const links = [...card.querySelectorAll('.product-image, .product-meta h3 a, .product-choice-link')];
    const status = card.querySelector('.product-choice-status');
    card.choiceController?.abort();
    const controller = new AbortController();
    card.choiceController = controller;
    card.setAttribute('data-choice-pending', '');
    links.forEach(link => { link.removeAttribute('href'); link.setAttribute('aria-disabled', 'true'); });
    status.textContent = card.dataset.choiceLoading;
    try {
      const url = new URL(card.dataset.productUrl, location.origin);
      url.searchParams.set('section_id', 'product-choice-state');
      url.searchParams.set('option_values', ids.join(','));
      const response = await fetch(url, {signal: controller.signal});
      if (!response.ok) throw new Error('Choice request failed');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = JSON.parse(documentFragment.querySelector('[data-product-choice-state]').textContent);
      if (card.choiceController !== controller) return;
      if (!state.id || !state.available || state.options?.length !== selected.length || !state.options.every((value, index) => value === selected[index])) {
        status.textContent = card.dataset.choiceUnavailable;
        return;
      }
      const destination = new URL(card.dataset.productUrl, location.origin);
      destination.searchParams.set('variant', state.id);
      links.forEach(link => { link.href = destination.pathname + destination.search; link.removeAttribute('aria-disabled'); });
      card.querySelector('.product-meta > strong').textContent = state.price;
      const image = card.querySelector('.product-image > img');
      if (image && state.image) { image.removeAttribute('srcset'); image.src = state.image; image.alt = state.alt; }
      status.textContent = '';
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = card.dataset.choiceError;
    } finally {
      if (card.choiceController === controller) card.removeAttribute('data-choice-pending');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
